import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Plus, Minus } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export function BalanceDialog({ open, onOpenChange, user, amount, setAmount, note, setNote, action, setAction, onSubmit }) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('balance')}</DialogTitle>
          <DialogDescription>{user?.full_name}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="bg-secondary/30 rounded-xl p-4 text-center">
            <div className="text-sm text-muted-foreground mb-1">{t('balance')}</div>
            <div className="text-3xl font-bold font-mono text-primary" data-testid="current-balance-display">
              ¥{(user?.balance || 0).toLocaleString()}
            </div>
          </div>
          <div className="flex gap-2">
            <Button variant={action === 'add' ? 'default' : 'outline'} className="flex-1 gap-2" onClick={() => setAction('add')} data-testid="balance-add-tab">
              <Plus className="h-4 w-4" />{t('deposit')}
            </Button>
            <Button variant={action === 'subtract' ? 'default' : 'outline'} className="flex-1 gap-2" onClick={() => setAction('subtract')} data-testid="balance-subtract-tab">
              <Minus className="h-4 w-4" />{t('withdraw')}
            </Button>
          </div>
          <div className="space-y-2">
            <Label>{t('amount')} (JPY)</Label>
            <Input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder={t('admin_users_amount_placeholder')} min="0" data-testid="balance-amount-input" />
          </div>
          <div className="space-y-2">
            <Label>{t('admin_kyc_notes')}</Label>
            <Input value={note} onChange={(e) => setNote(e.target.value)} data-testid="balance-note-input" />
          </div>
          {amount && parseFloat(amount) > 0 && (
            <div className="bg-secondary/20 rounded-lg p-3 text-sm" data-testid="balance-preview">
              <div className="flex justify-between">
                <span className="text-muted-foreground">{t('balance')}:</span>
                <span className="font-mono font-bold text-primary">
                  ¥{((user?.balance || 0) + (action === 'subtract' ? -parseFloat(amount) : parseFloat(amount))).toLocaleString()}
                </span>
              </div>
            </div>
          )}
          <Button className="w-full" onClick={onSubmit} data-testid="submit-balance-button">
            {action === 'add' ? t('deposit') : t('withdraw')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
